
import { getRequestLanguage } from '@/api/utils'
import { SetupContext, nextTick, ref } from 'vue'
import { Popup } from 'vant'

export default {
  name: 'GiftRankingRule',
  emits: ['onClose'],
  components: {
    [Popup.name as string]: Popup
  },
  setup(props: any, context: SetupContext) {
    const handleClose = () => {
      context.emit('onClose', false)
    }
    // const language = computed(() => {
    //   return getRequestLanguage()
    // })
    const rankingDiv = ref<Element | null>(null)
    nextTick(() => {
      if (rankingDiv.value) {
        rankingDiv.value.scrollLeft -= 10 // 将滚动条位置向左移动10px
      }
    })
    let language = getRequestLanguage()
    if (language.indexOf('zh') > -1) {
      if (language.indexOf('Hant') > -1 || language.indexOf('Hans') > -1) {
        language = 'zh'
      }
      language = 'zh'
    }

    const bg = require(`@/../src/assets/img/starlightChallenge/rule-bg-${language}.png`)
    let content = require(`@/../src/assets/img/starlightChallenge/rule-content-${language}.png`)
    const isMe = ['stableMe', 'stableSa', 'productionMe', 'productionSa'].includes(process.env.VUE_APP_ENV || 'development')
    if (isMe && language === 'en') {
      content = require('@/../src/assets/img/starlightChallenge/me-rule-content-en.png')
    } else if (isMe && language === 'zh') {
      content = require('@/../src/assets/img/starlightChallenge/me-rule-content-zh.png')
    }
    return {
      handleClose,
      language,
      content,
      bg
    }
  }

}
